module.exports = __webpack_public_path__ + "fonts/dosis-v7-latin-ext_latin-regular.b4373599.woff";